var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"app-modal-close",attrs:{"type":"button","aria-label":_vm.label,"title":"Close"},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('span',{staticClass:"app-modal-close__icon",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }